import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { getHostFeatureNameByRoute, isTrackableHostRoute } from '@config/telemetry';
import { sendHostTelemetryEvent } from '@services/telemetryService';

export const useHostPageViewTracking = (): void => {
  const router = useRouter();
  const prevPathnameRef = useRef<string>('');

  useEffect(() => {
    const handleRouteChange = (url: string, { shallow }: { shallow?: boolean } = {}) => {
      if (shallow) return;

      const pathname = url.split('?')[0];
      if (pathname === prevPathnameRef.current || !isTrackableHostRoute(pathname)) return;
      prevPathnameRef.current = pathname;

      sendHostTelemetryEvent({
        event_type: 'PAGE_VIEW',
        feature_name: getHostFeatureNameByRoute(pathname),
        page_route: pathname,
      });
    };

    handleRouteChange(router.asPath);
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router]);
};

export default useHostPageViewTracking;
